import { memo, createContext, useContext } from 'react'

export const ArticleContext = createContext({})

const ArticleProvider = memo(({ children, articleTitle }) => {
  return (
    <ArticleContext.Provider value={{ articleTitle }}>
      {children}
    </ArticleContext.Provider>
  )
})

const useArticle = () => {
  const context = useContext(ArticleContext)

  return context
}

ArticleProvider.displayName = 'ArticleProvider'

export { ArticleProvider, useArticle }
